import React from "react";
import Slider from "react-slick";
import { useSelector } from "react-redux";
import { URL } from "../Redux/common/url";

function HomeBgBanner() {
  const slider_list = useSelector((state) =>
    state?.allapi?.slider_list ? state?.allapi?.slider_list : {}
  );

  const ad = slider_list?.ads || [];

  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      {/* Inline Responsive CSS */}
     <style>
  {`
    .home-banner-img {
      width: 100%;
      height: 380px;
      object-fit: cover;
      border-radius: 12px;
    }

    @media(max-width: 1024px){
      .home-banner-img {
        height: 300px;
      }
    }

    /* MOBILE FIX - No image crop */
    @media(max-width: 768px){
      .home-banner-img {
        height: auto;
        max-height: 240px;
        object-fit: contain;
        border-radius: 10px;
      }
    }

    @media(max-width: 480px){
      .home-banner-img {
        height: auto;
        max-height: 400px;
        object-fit: contain;
        border-radius: 8px;
      }
    }
  `}
</style>

      {/* Slider Box */}
      <div
        style={{
          width: "95%",
          margin: "auto",
          marginTop: "10px",
          marginBottom: "20px",
          overflow: "hidden",
        }}
      >
        <Slider {...settings}>
          {ad?.map((data, i) => (
            <div key={i}>
              <img
                src={URL?.API_BASE_URL + data?.image}
                alt="Banner"
                className="home-banner-img"
              />
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
}

export default HomeBgBanner;
